import {UserAttributes} from '@optimizely/optimizely-sdk'
import {
  getDeviceCategory,
  getDevicePlatform,
  getIsVioFlutterApp,
  getLocaleCode,
  getUserAgent,
  getUserCountryCode
} from 'modules/meta/selectors'
import {RootState} from 'store'
import {getSrpSearchFlow, getTrafficSource} from 'utils/trafficSource'

import {
  getBrand,
  getBrandCode
} from '@vio/core/src/_web/brand/modules/selectors'
import {DevicePlatform} from '@vio/core/src/_web/utils/userAgent/types'
import {BrandCode} from '@vio/core/src/brand/types'
import {DeviceCategory} from '@vio/core/src/utils/userAgent/types'

export interface ExperimentSegmentationAttributes extends UserAttributes {
  application: string
  pathName: string
  env: string
  brandCode: BrandCode
  deviceCategory: DeviceCategory
  devicePlatform: DevicePlatform
  locale: string
  userCountry: string
  isWebView: boolean
  trafficSource: string
  profile: string
  label: string
  srpSearchFlow: 'seo' | 'regular'
  userAgent?: string
}

export const getExperimentSegmentationAttributes = (
  state: RootState,
  urlObject: URL
): ExperimentSegmentationAttributes => {
  const {searchParams: queryParams, pathname: pathName} = urlObject
  const brandCode = getBrandCode(state)
  const brand = getBrand(state)
  const trafficSource = getTrafficSource(
    queryParams.get('utm_source'),
    queryParams.get('label')
  )

  return {
    application: 'search',
    env: process.env.NEXT_PUBLIC_ENV || 'prd',
    pathName,

    brandCode,
    deviceCategory: getDeviceCategory(state),
    locale: getLocaleCode(state),
    isWebView: getIsVioFlutterApp(state),
    userCountry: getUserCountryCode(state),
    devicePlatform: getDevicePlatform(state),
    userAgent: getUserAgent(state),

    trafficSource,
    profile: queryParams.get('profile'),
    label: queryParams.get('label'),
    srpSearchFlow: getSrpSearchFlow(
      brand,
      trafficSource,
      queryParams.get('srpSearchFlow') ?? undefined
    )
  }
}
